import styled from "styled-components";

export default function Bairro() {
    return (
        <Content>
            <Header>
                <h1>Ipanema</h1>
                <span>Rio de Janeiro • RJ</span>
            </Header>

            <Section>
                <h2>Sobre o bairro</h2>
                <p>
                    Ipanema é um dos bairros mais emblemáticos e reconhecidos do Rio de Janeiro, com projeção internacional graças à sua praia, ao estilo de vida vibrante e à forte influência cultural. Localizado na Zona Sul da cidade, o bairro faz divisa com Copacabana, Leblon e Lagoa, ocupando uma área privilegiada entre o mar e a paisagem urbana carioca.
                </p>
                <p>
                    Sua história começa no final do século XIX, quando a região passou a ser urbanizada após a abertura do túnel que ligava Ipanema a Copacabana. O nome do bairro tem origem indígena, do tupi “Ipanema”, que significa “água ruim para pesca”. Ao longo do século XX, Ipanema consolidou-se como um importante centro cultural, tornando-se símbolo de modernidade, liberdade e inovação.
                </p>
                <p>
                    Foi em Ipanema que nasceu a Bossa Nova, imortalizada na canção “Garota de Ipanema”, que levou o nome do bairro ao mundo. Desde então, o local se destaca por seu espírito cosmopolita, reunindo artistas, intelectuais, movimentos sociais e tendências de comportamento. Hoje, Ipanema combina tradição e contemporaneidade, oferecendo uma infraestrutura completa, com praias famosas, comércio sofisticado, gastronomia diversificada e uma intensa vida ao ar livre, sendo referência de qualidade de vida no Rio de Janeiro.
                </p>
            </Section>

            <Section>
                <h2>Estilo de vida</h2>
                <p>
                    O estilo de vida em Ipanema é marcado por uma atmosfera descontraída e ao mesmo tempo vibrante, que reflete a identidade carioca em sua forma mais autêntica. O bairro convida à convivência ao ar livre, com suas ciclovias bem integradas, calçadões movimentados e ampla oferta de espaços para a prática de esportes como corrida, ciclismo, futevôlei, surfe e ioga à beira-mar.
                </p>
                <p>
                    Ipanema também se destaca como um importante polo gastronômico e boêmio, reunindo bares tradicionais, restaurantes renomados, cafés charmosos e estabelecimentos contemporâneos que atraem moradores e visitantes ao longo de todo o dia. A vida cultural é intensa e diversa, com galerias de arte, livrarias, música ao vivo e eventos que reforçam o caráter cosmopolita do bairro. Essa combinação de lazer, cultura e bem-estar faz de Ipanema um dos locais mais desejados para se viver e visitar no Rio de Janeiro.
                </p>
            </Section>
        </Content>
    );
}

const Content = styled.div`
  max-width: 900px;
  margin: 20px auto;
  padding: 24px;
  box-sizing: border-box;

  font-family: "Poppins", sans-serif;
  color: #333;

  background-color: #f0f8ffc7;
  border-radius: 20px;

  @media (max-width: 768px) {
    padding: 20px;
    margin: 16px;
  }

  @media (max-width: 480px) {
    padding: 16px;
    margin: 12px;
    border-radius: 16px;
  }
`;


const Header = styled.header`
  text-align: center;
  margin-bottom: 24px;

  h1 {
    font-size: 2.5rem;
    margin-bottom: 8px;
    font-weight: bold;
  }

  span {
    font-size: 1rem;
    color: #777;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2.1rem;
    }
  }

  @media (max-width: 480px) {
    h1 {
      font-size: 1.8rem;
    }

    span {
      font-size: 0.9rem;
    }
  }
`;


const Section = styled.section`
  margin-bottom: 24px;

  h2 {
    font-size: 1.6rem;
    margin-bottom: 12px;
    color: #0a6cff;
    font-weight: bold;
  }

  p {
    line-height: 1.7;
    margin: 10px 0;
    font-size: 1rem;
  }

  li {
    line-height: 1.7;
    margin: 10px 0;
  }

  span {
    font-weight: bold;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 1.4rem;
    }

    p,
    li {
      font-size: 0.95rem;
    }
  }

  @media (max-width: 480px) {
    h2 {
      font-size: 1.25rem;
    }

    p,
    li {
      font-size: 0.9rem;
      line-height: 1.6;
    }
  }
`;

